<template>
    <span @click="addAuctionToQuery(auction.id)">{{ auction.name }} <input type="checkbox" v-model="isActive" /></span>
</template>
<script>
    export default {
        props: ['auction', 'region'],
        methods: {
            addAuctionToQuery: function (auctionId) {
                if ( this.$store.getters.getQueryAuctionByIdStock(auctionId).length === 0 ) {
                    this.$store.dispatch('addAuctionToQueryStock', auctionId)
                } else {
                    this.$store.dispatch('removeAuctionFromQueryStock', auctionId)
                }
            }
        },
        computed: {
            isActive: {
                get: function () {
                    return this.$store.getters.getQueryAuctionByIdStock(this.auction.id).length !== 0
                },
                set: function (value) {

                }
            }
        }
    }
</script>

<style scoped>
    span {
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/AuctionStock.vue